export const OPPOSITE_POSITION: any = {
  left: "right",
  right: "left",
  topLeft: "bottomRight",
  topRight: "bottomLeft",
  bottomLeft: "topRight",
  bottomRight: "topLeft",
};
export const HOTEL_CODES: any = {
  "amanaki-thao-dien": "491275",
  "amanaki-boutique-saigon": "70AS04",
};
export const NAVS: any = {
  en: {
    group: {
      title: "Amanaki Hotels",
      data: [
        {
          label: "Home",
          href: "home",
        },
        {
          label: "About Amanaki",
          src: "/home/about.jpg",
          child: [
            {
              label: "About Us",
              href: "about-us",
            },
            {
              label: "Sustainbility",
              href: "about-sustainability",
            },
            {
              label: "Carreers",
              href: "about-careers",
            },
          ],
        },
        {
          label: "Our Hotels",
          subLabel: "Discover Our Hotels",
          src: "/home/about.jpg",
          child: [
            {
              label: "Amanaki Saigon Boutique",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "Amanaki Thao Dien",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "Contact Us",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "Amanaki Thao Dien",
      data: [
        {
          label: "home",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "brand story",
              value: "brand-story",
            },
            {
              label: "arts & Amanaki",
              value: "arts",
            },
          ],
          child: [
            {
              label: "brand story",
              href: "brand-story",
            },
            {
              label: "arts & Amanaki",
              href: "arts",
            },
          ],
          label: "the hotel",
          type: "select",
        },
        {
          label: "rooms",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "wellness",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "dining",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "events",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "offers",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "blog",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "Discover Saigon",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "Amanaki Boutique Saigon",
      data: [
        {
          label: "home",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "the hotel",
          type: "link",
          routeName: "theHotel",
          href: "theHotel",
        },
        {
          label: "rooms",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "Facilities & Service",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "offers",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "blog",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "Discover Saigon",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
  vi: {
    group: {
      title: "Amanaki Hotels",
      data: [
        {
          label: "Trang Chủ",
          href: "home",
        },
        {
          label: "Về Amanaki",
          src: "/home/about.jpg",
          child: [
            {
              label: "Giới thiệu",
              href: "about-us",
            },
            {
              label: "Phát triển bền vững",
              href: "about-sustainability",
            },
            {
              label: "Nghề nghiệp",
              href: "about-careers",
            },
          ],
        },
        {
          label: "Các khách sạn",
          subLabel: "Khám phá khách sạn",
          src: "/home/about.jpg",
          child: [
            {
              label: "Amanaki Sài Gòn Boutique",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "Amanaki Thảo Điền",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "Liên hệ Amanaki",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "Amanaki Thảo Điền",
      data: [
        {
          label: "Trang chủ",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "Câu chuyện Amanaki Thảo Điền",
              value: "brand-story",
            },
            {
              label: "Nghệ thuật và Amanaki",
              value: "arts",
            },
          ],
          child: [
            {
              label: "Câu chuyện Amanaki Thảo Điền",
              href: "brand-story",
            },
            {
              label: "Nghệ thuật và Amanaki",
              href: "arts",
            },
          ],
          label: "Khách sạn",
          type: "select",
        },
        {
          label: "Phòng nghỉ",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "Sức khỏe",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "Nhà hàng",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "Sự kiện",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "Ưu đãi",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "Bài viết",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "Khám phá Sài Gòn",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "Amanaki Sài Gòn Boutique",
      data: [
        {
          label: "Trang chủ",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "Khách sạn",
          type: "link",
          href: "theHotel",
          routeName: "theHotel",
        },
        {
          label: "Phòng nghỉ",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "Cơ sở vật chất & Dịch vụ",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "Ưu đãi",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "Bài viết",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "Khám phá Sài Gòn",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
  ja: {
    group: {
      title: "アマナキ ホテル",
      data: [
        {
          label: "ホーム",
          href: "home",
        },
        {
          label: "アマナキについて",
          src: "/home/about.jpg",
          child: [
            {
              label: "会社概要",
              href: "about-us",
            },
            {
              label: "持続可能性",
              href: "about-sustainability",
            },
            {
              label: "採用情報",
              href: "about-careers",
            },
          ],
        },
        {
          label: "ホテル紹介",
          subLabel: "ホテルを探索",
          src: "/home/about.jpg",
          child: [
            {
              label: "アマナキ サイゴン ブティック",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "アマナキ タオディエン",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "お問い合わせ",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "アマナキ タオディエン",
      data: [
        {
          label: "ホーム",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "ブランドストーリー",
              value: "brand-story",
            },
            {
              label: "アート & アマナキ",
              value: "arts",
            },
          ],
          child: [
            {
              label: "ブランドストーリー",
              href: "brand-story",
            },
            {
              label: "アート & アマナキ",
              href: "arts",
            },
          ],
          label: "ホテル",
          type: "select",
        },
        {
          label: "客室",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "ウェルネス",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "ダイニング",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "イベント",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "オファー",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "ブログ",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "サイゴンを探索",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "アマナキ サイゴン ブティック",
      data: [
        {
          label: "ホーム",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "ホテル",
          type: "link",
          routeName: "theHotel",
          href: "theHotel",
        },
        {
          label: "客室",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "施設・サービス",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "オファー",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "ブログ",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "サイゴンを探索",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
  ko: {
    group: {
      title: "아마나키 호텔",
      data: [
        {
          label: "홈",
          href: "home",
        },
        {
          label: "아마나키 소개",
          src: "/home/about.jpg",
          child: [
            {
              label: "회사 소개",
              href: "about-us",
            },
            {
              label: "지속가능성",
              href: "about-sustainability",
            },
            {
              label: "채용",
              href: "about-careers",
            },
          ],
        },
        {
          label: "호텔 소개",
          subLabel: "호텔 둘러보기",
          src: "/home/about.jpg",
          child: [
            {
              label: "아마나키 사이공 부티크",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "아마나키 타오디엔",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "문의하기",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "아마나키 타오디엔",
      data: [
        {
          label: "홈",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "브랜드 스토리",
              value: "brand-story",
            },
            {
              label: "아트 & 아마나키",
              value: "arts",
            },
          ],
          child: [
            {
              label: "브랜드 스토리",
              href: "brand-story",
            },
            {
              label: "아트 & 아마나키",
              href: "arts",
            },
          ],
          label: "호텔",
          type: "select",
        },
        {
          label: "객실",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "웰니스",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "다이닝",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "이벤트",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "특가",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "블로그",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "사이공 둘러보기",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "아마나키 사이공 부티크",
      data: [
        {
          label: "홈",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "호텔",
          type: "link",
          routeName: "theHotel",
          href: "theHotel",
        },
        {
          label: "객실",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "시설 및 서비스",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "특가",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "블로그",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "사이공 둘러보기",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
  zh: {
    group: {
      title: "Amanaki 酒店",
      data: [
        {
          label: "首页",
          href: "home",
        },
        {
          label: "关于 Amanaki",
          src: "/home/about.jpg",
          child: [
            {
              label: "关于我们",
              href: "about-us",
            },
            {
              label: "可持续发展",
              href: "about-sustainability",
            },
            {
              label: "职业发展",
              href: "about-careers",
            },
          ],
        },
        {
          label: "我们的酒店",
          subLabel: "探索我们的酒店",
          src: "/home/about.jpg",
          child: [
            {
              label: "Amanaki 西贡精品酒店",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "Amanaki 草甸酒店",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "联系我们",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "Amanaki 草甸酒店",
      data: [
        {
          label: "首页",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "品牌故事",
              value: "brand-story",
            },
            {
              label: "艺术与 Amanaki",
              value: "arts",
            },
          ],
          child: [
            {
              label: "品牌故事",
              href: "brand-story",
            },
            {
              label: "艺术与 Amanaki",
              href: "arts",
            },
          ],
          label: "酒店",
          type: "select",
        },
        {
          label: "客房",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "健康养生",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "餐饮",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "活动",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "优惠",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "博客",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "探索西贡",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "Amanaki 西贡精品酒店",
      data: [
        {
          label: "首页",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "酒店",
          type: "link",
          routeName: "theHotel",
          href: "theHotel",
        },
        {
          label: "客房",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "设施与服务",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "优惠",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "博客",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "探索西贡",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
  "zh-HK": {
    group: {
      title: "Amanaki 酒店",
      data: [
        {
          label: "首頁",
          href: "home",
        },
        {
          label: "關於 Amanaki",
          src: "/home/about.jpg",
          child: [
            {
              label: "關於我們",
              href: "about-us",
            },
            {
              label: "可持續發展",
              href: "about-sustainability",
            },
            {
              label: "職業發展",
              href: "about-careers",
            },
          ],
        },
        {
          label: "我們的酒店",
          subLabel: "探索我們的酒店",
          src: "/home/about.jpg",
          child: [
            {
              label: "Amanaki 西貢精品酒店",
              href: "amanaki-boutique-saigon",
            },
            {
              label: "Amanaki 草甸酒店",
              href: "amanaki-thao-dien",
            },
          ],
        },
        {
          label: "聯絡我們",
          href: "contact",
        },
      ],
    },
    "amanaki-thao-dien": {
      title: "Amanaki 草甸酒店",
      data: [
        {
          label: "首頁",
          routeName: "amanaki-thao-dien",
          href: "amanaki-thao-dien",
          type: "link",
        },
        {
          src: "/home/about.jpg",
          options: [
            {
              label: "品牌故事",
              value: "brand-story",
            },
            {
              label: "藝術與 Amanaki",
              value: "arts",
            },
          ],
          child: [
            {
              label: "品牌故事",
              href: "brand-story",
            },
            {
              label: "藝術與 Amanaki",
              href: "arts",
            },
          ],
          label: "酒店",
          type: "select",
        },
        {
          label: "客房",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "健康養生",
          routeName: "wellness",
          href: "wellness",
          type: "link",
        },
        {
          label: "餐飲",
          routeName: "dinning",
          href: "dinning",
          type: "link",
        },
        {
          label: "活動",
          routeName: "meeting-and-events",
          href: "meeting-and-events",
          type: "link",
        },
        {
          label: "優惠",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "網誌",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "探索西貢",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
    "amanaki-boutique-saigon": {
      title: "Amanaki 西貢精品酒店",
      data: [
        {
          label: "首頁",
          routeName: "amanaki-boutique-saigon",
          href: "amanaki-boutique-saigon",
          type: "link",
        },
        {
          label: "酒店",
          type: "link",
          routeName: "theHotel",
          href: "theHotel",
        },
        {
          label: "客房",
          routeName: "rooms",
          href: "rooms",
          type: "link",
        },
        {
          label: "設施與服務",
          routeName: "facilities-service",
          href: "facilities-service",
          type: "link",
        },
        {
          label: "優惠",
          routeName: "offers",
          href: "offers",
          type: "link",
        },
        {
          label: "網誌",
          routeName: "stories",
          href: "stories",
          type: "link",
        },
        {
          label: "探索西貢",
          routeName: "discover",
          href: "discover",
          type: "link",
        },
      ],
    },
  },
};
export const MENU_NAVS = [
  {
    placeholder: "the hotel",
    options: [
      {
        label: "Brand story",
        value: "brand-story",
      },
      {
        label: "Arts and Amanaki",
        value: "arts",
      },
    ],
    type: "select",
  },
  {
    label: "rooms",
    routeName: "rooms",
    type: "link",
  },
  {
    label: "wellness",
    routeName: "wellness",
    type: "link",
  },
  {
    label: "dinning",
    routeName: "dinning",
    type: "link",
  },
  {
    label: "events",
    routeName: "meeting-and-events",
    type: "link",
  },
  {
    label: "offers",
    routeName: "offers",
    type: "link",
  },
  {
    label: "blog",
    routeName: "stories",
  },
  {
    label: "discover saigon",
    routeName: "discover",
    type: "link",
  },
];
